<template>
  <div class="topicinfobox" >
    <header><a class="back" href="/#/topic"><div class="arrow-left"><div class="arrow"></div></div></a>{{msg}}</header>

    <div class="topicbox">
        <div class="topicupper">
            <h2>{{topicinfo.title}}</h2>
            <span class="editor">{{topicinfo.entname}}</span><span class="time">{{topicinfo.publishdate}}</span>
        </div>
        <!-- 可能有图片 -->
        <div class="articlebox">
            <div v-html="topicinfo.content"></div>
        </div>
        <div class="commentlist">
           <ul>
               <li v-for="item in commentResult.commentList" >
                   <a class="clickjump" v-on:click="downLoad">
                       <div class="comment-left">
                           <div class="name">{{item.author}}</div>
                           <div class="time">{{item.commenttime}}</div>
                       </div>
                       <div class="comment-right">
                          <p v-html="item.comment"></p>
                           <div class="commentimg"><img :src="item.image"></div>
                       </div>
                   </a>
               </li>
           </ul>
           <div class="morecomment" v-show="commentResult.totalItems>3">
               <a class="clickjump" v-on:click="downLoad">
                   <span class="mareimg"><img src="../assets/more.png"></span>
                   <span class="moretext">全部评论（139）</span>
               </a>
           </div>
        </div>
        <div class="articlelist">
            <div class="list-tit">相关话题</div>
                <ul>
                    <li v-for="item in topiclistResult">
                        <a class="clickjump" v-on:click="downLoad">
                            <div class="article-left"><img :src="item.imgurl"></div>
                            <div class="article-right">
                                <h5>{{item.title}}</h5>
                                <div class="author-time">
                                    <span class="time">{{item.publishdate}}</span>
                                    <span class="author">{{item.entname}}</span>
                                </div>
                                <h6>{{item.summary}}</h6>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
     </div>

    <DownloadApp></DownloadApp>

     <div id="J_ErrorTip" class="error-tip"></div>

    <MenuFooters :isHide="isHide" :menuType="currentMenuType"></MenuFooters>
  </div>
</template>
<script>
import axios from 'axios'
import { setSid, getSid, setMarkId, getMarkId } from '../utils/SidManager';
import getConfig from '../utils/config'
import {getUrl} from '../utils/WebRequest'
import {errorTip} from '../utils/util'
import MenuFooters from './Footer'
import DownloadApp from './DownloadApp'
var config = getConfig();

export default {
  name: 'TopicInfo',
  components: {
    MenuFooters,
    DownloadApp
  },
  data () {
    return {
      msg: '话题详情',
      topic:{ topicid: this.$route.params.topicId, sid: getSid() || '', markid: getMarkId() || ''},
      topicResult:{},
      topicinfo:{},

      commentResult:{commentList:[],totalItems:0},
      topiclistResult:{topiclistList:[],totalItems:0},
      currentMenuType: 'topic',
      isHide:false
    }
  },

  methods: {
        downLoad: function(){
           $('.downloadpage').show();
        },

         shareOK: function(){
                let args = JSON.stringify({topicid:this.$route.params.topicId,"sid":getSid() || ''});
               	axios.post(getUrl(config.url_map.share),JSON.parse(args),function(result){
                       //alert('已分享');
                     });

         },

       getTopicInfo: function(){
            var formData = JSON.stringify(this.topic);

           axios.post(getUrl(config.url_map.topicInfo), JSON.parse(formData))
               .then(function(res) {
                   if (res.data.status.error_code === 0) {
                        this.topicResult = res.data.bizobj;
                        this.topicinfo = res.data.bizobj.topicinfo;
                        setMarkId(res.data.bizobj.topicinfo.markid);

                      var that = this;
                      if(res.data.bizobj.share && res.data.bizobj.share.microflag == "1"){
                               wx.config({
                                 debug: false,
                                 appId: res.data.bizobj.share.para.appId,
                                 timestamp:res.data.bizobj.share.para.timeStamp,
                                 nonceStr: res.data.bizobj.share.para.nonceStr,
                                 signature: res.data.bizobj.share.para.signature,
                                 jsApiList: [
                                     // 所有要调用的 API 都要加到这个列表中
                                     'checkJsApi',
                                     'onMenuShareQQ',
                                     'onMenuShareTimeline',
                                     'onMenuShareAppMessage'
                                   ]
                               });

                               wx.ready(function () {

                                 wx.checkJsApi({
                                    jsApiList: [
                                        'checkJsApi',
                                        'onMenuShareQQ',
                                        'onMenuShareTimeline',
                                        'onMenuShareAppMessage'
                                    ],
                                    success: function (res) {
                                        //alert(JSON.stringify(res));
                                    }
                                 });

                                 //朋友圈
                                 //document.getElementById('ShareTimeline').onclick = function () {
                                   wx.onMenuShareTimeline({
                                     title:res.data.bizobj.share.para.shareTitle,
                                     link: res.data.bizobj.share.para.shareUrl,
                                     imgUrl: res.data.bizobj.share.para.sharePicUrl,
                                     trigger: function (res) {
                                         //alert('用户点击分享到朋友圈');
                                     },
                                     success: function (res) {
                                     	that.shareOK();
                                     },
                                     cancel: function (res) {
                                         //alert('已取消');
                                     },
                                     fail: function (res) {
                                         alert('wx.onMenuShareTimeline:fail: '+JSON.stringify(res));
                                     }
                                   });
                                   //alert('已注册获取“分享到朋友圈”状态事件');
                                 //};

                                 // 2. 分享接口
                                 // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
                                 wx.onMenuShareAppMessage({
                                   title:res.data.bizobj.share.para.shareTitle,
                                   link: res.data.bizobj.share.para.shareUrl,
                                   imgUrl: res.data.bizobj.share.para.sharePicUrl,
                                   desc: res.data.bizobj.share.para.shareDesc,
                                   trigger: function (res) {
                                     // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                                   //  alert('用户点击发送给朋友');
                                   },
                                   success: function (res) {
                                     that.shareOK();
                                   },
                                   cancel: function (res) {
                                    // alert('已取消');
                                   },
                                   fail: function (res) {
                                     alert(JSON.stringify(res));
                                   }
                                 });

                                 // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
                                 wx.onMenuShareQQ({
                                   title:res.data.bizobj.share.para.shareTitle,
                                   link: res.data.bizobj.share.para.shareUrl,
                                   imgUrl: res.data.bizobj.share.para.sharePicUrl,
                                   desc:res.data.bizobj.share.para.shareDesc,
                                   trigger: function (res) {
                                     //alert('用户点击分享到QQ');
                                   },
                                   complete: function (res) {
                                     //alert(JSON.stringify(res));
                                   },
                                   success: function (res) {
                                     that.shareOK();
                                   },
                                   cancel: function (res) {
                                     //alert('已取消');
                                   },
                                   fail: function (res) {
                                     alert(JSON.stringify(res));
                                   }
                                 });

                                 wx.error(function (res) {
                                 	alert('放慢脚步，等我一下，正在拼命加载中...');
                                   //alert('wx.error: '+JSON.stringify(res));
                                 });

                               });
                      }


                    //this.topicResult = res.data.bizobj[0];
                    //setMarkId(res.data.bizobj[0].markid);
                   } else {
                    errorTip($('#J_ErrorTip'),res.data.status.error_msg);
                   }
               }.bind(this))
               .catch(function(err) {
                 console.log(err);
               });
       },

       getTopicComment: function(){
          this.topic.pagesize = 3;
          var formData = JSON.stringify(this.topic);

          axios.post(getUrl(config.url_map.commentList), JSON.parse(formData))
              .then(function(res) {
                  if (res.data.status.error_code === 0) {
                   this.commentResult.commentList = res.data.bizobj;
                   this.commentResult.totalItems = res.data.page_info.total_items;
                  } else {
                   errorTip($('#J_ErrorTip'),res.data.status.error_msg);
                  }
              }.bind(this))
              .catch(function(err) {
                console.log(err);
              });
        },
       getTopicList: function(){
          var formData = JSON.stringify(this.topic);

          axios.post(getUrl(config.url_map.topicList), JSON.parse(formData))
              .then(function(res) {
                  if (res.data.status.error_code === 0) {
                   this.topiclistResult = res.data.bizobj;
                    this.topiclistResult.totalItems = res.data.page_info.total_items;
                  } else {
                   errorTip($('#J_ErrorTip'),res.data.status.error_msg);
                  }
              }.bind(this))
              .catch(function(err) {
                console.log(err);
              });
       }
  },

  created: function(){
    this.getTopicInfo();
    this.getTopicComment();
    this.getTopicList();
  }
}
</script>



// WEBPACK FOOTER //
// TopicInfo.vue?71dd8c2c